module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/assessment_achievements/1@2x_7f4f64b50ab1b65c32f21ac8bb327187.png";